import { DataLayerEventsEnum } from '~/types/dataLayer'

export function useCta() {
  const config = useRuntimeConfig()
  const trackEvent = useTrackEvent()
  const { t } = useI18n()

  function handleLogin() {
    return navigateTo(`${config.public.dmatWebUrl}/auth/login`, { external: true })
  }
  function handleRegister() {
    trackEvent({
      eventName: DataLayerEventsEnum.Click,
      clickData: {
        id: 'h~$~button_primary~investor_app~$~$~0',
        text: t('navigation.actions.cta'),
        value: 0,
        url: `${config.public.dmatWebUrl}/auth/register/email`,
      },
    })

    return navigateTo(`${config.public.dmatWebUrl}/auth/register/email`, { external: true })
  }

  return {
    handleLogin,
    handleRegister,
  }
}
